export const brands = [
  {
    label: "Pokemon",
    value: "pokemon",
  },
  {
    label: "Nintendo",
    value: "nintendo",
  },
  {
    label: "WIXOSS",
    value: "wixoss",
  },
  {
    label: "Blizzard",
    value: "blizzard",
  },
];

export const conditions = [
  {
    label: "New/Factory Sealed",
    value: "new_factory_sealed",
  },
  {
    label: "Near Mint",
    value: "near_mint",
  },
  {
    label: "Excellent",
    value: "excellent",
  },
  {
    label: "Very Good",
    value: "very_good",
  },
  {
    label: "Poor",
    value: "poor",
  }
];

export const rarities = [
  {
    label: "Common",
    value: "common",
  },
  {
    label: "Rare",
    value: "rare",
  },
  {
    label: "Ultra Rare",
    value: "ultra_rare",
  },
  {
    label: "Legendary",
    value: "legendary",
  },
];

export const boxTypes = [
  {
    label: "Booster Box",
    value: "boosterBox",
  },
  {
    label: "Elite Trainer Box",
    value: "eliteTrainerBox",
  },
  {
    label: "Sleeved Packs",
    value: "sleevedPacks",
  },
  {
    label: "Loose Packs",
    value: "loosePacks",
  },
  {
    label: "Hobby Box",
    value: "hobbyBox",
  },
  {
    label: "Blaster",
    value: "blaster",
  },
  {
    label: "Breaker",
    value: "breaker",
  },
  {
    label: "Mega",
    value: "mega",
  },
  {
    label: "Tins",
    value: "tins",
  },
  {
    label: "Hangers",
    value: "hangers",
  },
  {
    label: "Other",
    value: "other",
  },
];

// Selling volume is no longer capped by plan -- every paid plan sells as much
// as it likes, and the plan only decides the transaction-fee ladder applied to
// each item's price (see utils/fees.js). `fee` is the Stripe processing charge
// bundled into the membership price, not a transaction fee.
export const memberships = {
  free: {
    price: 0,
  },
  basic: {
    price: 50,
    fee: 1.8,
    benefits: [
      "Unlimited listings and sales every month",
      "Tiered transaction fees: 8% down to 2% by item price",
      "Easily chat with buyers and sellers",
      "Withdraw earnings after a 7-day clearing period",
    ],
    priceId: "price_1SqY4JA4SfnomAmtKGcpFFBt", // Updated Basic Price ID to include processing fee
  },
  basicYearly: {
    price: 500,
    fee: 16,
    benefits: [
      "Unlimited listings and sales every month",
      "Tiered transaction fees: 8% down to 2% by item price",
      "Easily chat with buyers and sellers",
      "Withdraw earnings after a 7-day clearing period",
    ],
    priceId: "price_1TdU8ZA4SfnomAmtYaZpLskm", // Updated Basic Yearly Price ID to include processing fee (same as monthly since yearly discount is not applied)
  },
  pro: {
    price: 100,
    fee: 3.3,
    benefits: [
      "Unlimited listings and sales every month",
      "Transaction fees capped at 5%, down to 2% by item price",
      "Withdraw earnings after 3 days, not 7",
      "Priority support via email",
      "All features from Tier 1 included",
    ],
    priceId: "price_1SqY5DA4SfnomAmtE6fl0ukf", // Updated Pro Price ID to include processing fee
  },
  proYearly: {
    price: 1000,
    fee: 31,
    benefits: [
      "Unlimited listings and sales every month",
      "Transaction fees capped at 5%, down to 2% by item price",
      "Withdraw earnings after 3 days, not 7",
      "Priority support via email",
      "All features from Tier 1 included",
    ],
    priceId: "price_1TddaVA4SfnomAmtyiUGX83E", // Updated Pro Yearly Price ID to include processing fee (same as monthly since yearly discount is not applied)
  },
  elite: {
    price: 250,
    fee: 8.03,
    benefits: [
      "Unlimited listings and sales every month",
      "Flat 2% transaction fee on every sale",
      "Withdraw earnings after 3 days, not 7",
      "Top-priority support via email",
      "All features from Tier 1-2 included",
    ],
    priceId: "price_1SqY5dA4SfnomAmt1i9h4wHi", // Updated Elite Price ID to include processing fee
  },
  eliteYearly: {
    price: 2500,
    fee: 80,
    benefits: [
      "Unlimited listings and sales every month",
      "Flat 2% transaction fee on every sale",
      "Withdraw earnings after 3 days, not 7",
      "Top-priority support via email",
      "All features from Tier 1-2 included",
    ],
    priceId: "price_1Tddc5A4SfnomAmtizkW6nWT", // Updated Elite Yearly Price ID to include processing fee (same as monthly since yearly discount is not applied)
  },
};

export const homeCategorySliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3.5,
  slidesToScroll: 1,
  arrows: false,
  customPaging: function (i) {
    return (
      <div className="slick-dot w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></div>
    );
  },
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
